/** The default size for grid layouts */
export const DEFAULT_GRID_LAYOUT_WIDTH = 1120;
export const DEFAULT_NUM_SNAP_POINTS = 24;

/**
 * The number of total "sections"/fractional units we use when storing the start/end
 * positions of each grid column in a row.
 */
// Why 120? Because its divisible by a lot of things, in fact, it's a "superior highly composite number"!
export const NUM_ROW_SEGMENTS = 120;
/** Vertical whitespace in px between top-level GridRows */
export const GRID_ROW_GAP = 24;
/** Horizontal whitespace in px between columns in a row */
export const GRID_COLUMN_GAP = 16;
/** Vertical whitespace in px between elements in a column */
export const GRID_ELEMENT_COL_GAP = 16;
/** Extra L/R padding per parent row. This makes the spacing on the left/right of a row the same as above or below it. */
export const GRID_ROW_HORIZONTAL_PADDING = (GRID_ROW_GAP - GRID_COLUMN_GAP) / 2;
